var map;
var infoBubble;
var gis;
var vendors = [];
var types = [];
var scales = [];
var showvendors = [];
var showtypes = [];
var showscales = [];

function initMap() {
  if (map) return;

  var mapEl = document.getElementById('map');
  if (!mapEl) return;

  var bounds = new google.maps.LatLngBounds();
  var otherPolys = [];
  var gisIndex = null;
  var resultRecords = [];

  function getCoords(dataArray) {
    var coords = dataArray[1];
    var scale = dataArray[2];
    var vendor = dataArray[3];

    if (coords == '') {
      var latS, latN, lonW, lonE, col, row;

      if (scale >= 250000) {
        var letters = ['c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k'];
        var num = dataArray[0].replace(vendor, '').match(/.{1,2}/g);

        row = letters.indexOf(num[0].replace('s', '')) + 2;
        col = parseInt(num[1]);

        lonW = parseFloat((col - 49) * 6) + 108;
        lonE = parseFloat(lonW + 6);
        latN = parseFloat(row * -4);
        latS = parseFloat(latN - 4);

        if (scale == 250000) {
          num = dataArray[0].replace(vendor, '').match(/.{1,5}/g);
          num = parseInt(num[1]);

          if (num <= 4) {
            latS += 3;
          } else if (num <= 8) {
            latS += 2;
            latN -= 1;
          } else if (num <= 12) {
            latS += 1;
            latN -= 2;
          } else {
            latN -= 3;
          }

          if (num == 1 || num == 5 || num == 9 || num == 13) {
            lonE -= 1.5 * 3;
          } else if (num == 2 || num == 6 || num == 10 || num == 14) {
            lonE -= 1.5 * 2;
            lonW += 1.5;
          } else if (num == 3 || num == 7 || num == 11 || num == 15) {
            lonE -= 1.5;
            lonW += 1.5 * 2;
          } else {
            lonW += 1.5 * 3;
          }
        }
      }

      if (scale <= 100000) {
        var num = dataArray[0].replace(vendor, '').match(/.{1,2}/g);

        col = num[0];
        row = num[1];

        lonW = parseFloat(col * 0.5 + 105.5);
        lonE = parseFloat(lonW + 0.5);
        latS = parseFloat(-49 + row * 0.5);
        latN = parseFloat(latS + 0.5);

        if (vendor != 'nsw' && vendor != 'tas') {
          if (scale <= 50000) {
            quad = parseInt(num[2].replace('-', ''));
            if (quad == 1 || quad == 2) lonW += 0.25;
            if (quad == 3 || quad == 4) lonE -= 0.25;
            if (quad == 1 || quad == 4) latS += 0.25;
            if (quad == 2 || quad == 3) latN -= 0.25;

            if (scale <= 25000) {
              quad = parseInt(num[3]);
              if (quad == 1 || quad == 2) lonW += 0.125;
              if (quad == 3 || quad == 4) lonE -= 0.125;
              if (quad == 1 || quad == 4) latS += 0.125;
              if (quad == 2 || quad == 3) latN -= 0.125;
            }
          }
        } else if (vendor == 'nsw') {
          if (scale <= 50000) {
            quad = num[2].replace('-', '');
            if (quad == 'n') latS += 0.25;
            if (quad == 's') latN -= 0.25;
          }
          if (scale <= 25000) {
            quad = parseInt(num[2].replace('-', ''));
            if (quad == 1 || quad == 2) lonW += 0.25;
            if (quad == 3 || quad == 4) lonE -= 0.25;
            if (quad == 1 || quad == 4) latS += 0.25;
            if (quad == 2 || quad == 3) latN -= 0.25;

            quad = num[3];
            if (quad == 'n') latS += 0.125;
            if (quad == 's') latN -= 0.125;
          }
        }
      }
      coords = [
        [latN, lonW],
        [latN, lonE],
        [latS, lonE],
        [latS, lonW],
        [latN, lonW]
      ];
    }

    var coordsArray = [];
    for (var c = 0; c < coords.length; c++) {
      coordsArray.push({ lat: coords[c][0], lng: coords[c][1] });
    }
    return coordsArray;
  }

  function createPoly(dataArray, coords, weight, content) {
    var setColour;

    if (
      (dataArray[4] == 'map' || dataArray[4] == 'folded_map') &&
      dataArray[3] != 'hema' &&
      dataArray[3] != 'world'
    ) {
      setColour = colours[dataArray[3] + dataArray[2] + dataArray[5]];
    } else {
      setColour = colours[dataArray[3]];
    }

    var zIndexAdj = 0;
    if (dataArray[4] == 'chart' && dataArray[5] == 'y') {
      setColour = '#666666';
    }

    var thisPoly = new google.maps.Polygon({
      paths: coords,
      strokeColor: setColour,
      strokeOpacity: 1,
      strokeWeight: 1,
      fillColor: setColour,
      fillOpacity: 0,
      name: dataArray[0].toLowerCase(),
      scale: dataArray[2],
      zIndex: 1000 - scaleList.indexOf(dataArray[2]) + zIndexAdj,
      vendor: dataArray[3],
      productType: dataArray[4],
      show: true,
      normColour: setColour,
      popUpContent: content
    });
    return thisPoly;
  }

  function setMapandListeners(poly) {
    poly.setMap(map);
    google.maps.event.addListener(poly, 'mouseover', function () {
      this.setOptions({ fillOpacity: 0.35 });
    });
    google.maps.event.addListener(poly, 'mouseout', function () {
      this.setOptions({ fillOpacity: 0.0 });
    });
    poly.addListener('click', openInfoBubble);
  }

  function addListToIndex(list, index) {
    if (!list) return;
    for (var i = 0; i < list.length; i++) {
      index[list[i][0].toLowerCase()] = list[i];
    }
  }

  function buildGisIndex() {
    var index = {};
    addListToIndex(typeof chart_list !== 'undefined' ? chart_list : null, index);
    addListToIndex(typeof map_list !== 'undefined' ? map_list : null, index);
    addListToIndex(typeof enc_list !== 'undefined' ? enc_list : null, index);
    addListToIndex(typeof ukho_list !== 'undefined' ? ukho_list : null, index);
    addListToIndex(typeof pub_list !== 'undefined' ? pub_list : null, index);
    return index;
  }

  function recordsForResults() {
    if (!gisIndex) gisIndex = buildGisIndex();
    var records = [];
    var seen = {};
    for (var i = 0; i < showOnly.length; i++) {
      var handle = String(showOnly[i]).toLowerCase();
      if (seen[handle]) continue;
      seen[handle] = true;
      if (gisIndex[handle]) records.push(gisIndex[handle]);
    }
    return records;
  }

  function clearPolys() {
    for (var c = 0; c < otherPolys.length; c++) {
      otherPolys[c].setMap(null);
    }
    otherPolys = [];
  }

  function drawMatching(fit) {
    var viewBounds = new google.maps.LatLngBounds();
    clearPolys();

    for (var c = 0; c < resultRecords.length; c++) {
      var dataArray = resultRecords[c];
      if (
        !showvendors.includes(dataArray[3]) ||
        !showtypes.includes(dataArray[4]) ||
        !showscales.includes(String(dataArray[2]))
      ) {
        continue;
      }

      var a = showOnly.indexOf(dataArray[0].toLowerCase());
      var content = contentArray[a];
      var coords = getCoords(dataArray);
      for (var ll = 0; ll < coords.length; ll++) {
        viewBounds.extend(coords[ll]);
      }
      var poly = createPoly(dataArray, coords, 2, content);
      setMapandListeners(poly);
      otherPolys.push(poly);
    }

    if (fit && !viewBounds.isEmpty()) {
      map.fitBounds(viewBounds);
    }
  }

  map = new google.maps.Map(mapEl, {
    mapTypeId: 'roadmap',
    zoom: 3,
    center: { lat: -35, lng: 140 },
    streetViewControl: false,
    clickableIcons: false,
    keyboardShortcuts: false,
    gestureHandling: 'cooperative'
  });

  resultRecords = recordsForResults();

  for (var c = 0; c < resultRecords.length; c++) {
    var dataArray = resultRecords[c];
    var a = showOnly.indexOf(dataArray[0].toLowerCase());
    var content = contentArray[a];
    var coords = getCoords(dataArray);

    for (var ll = 0; ll < coords.length; ll++) {
      bounds.extend(coords[ll]);
    }

    var poly = createPoly(dataArray, coords, 2, content);
    setMapandListeners(poly);
    otherPolys.push(poly);

    if (vendors.indexOf(dataArray[3]) == -1) vendors.push(dataArray[3]);
    if (types.indexOf(dataArray[4]) == -1) types.push(dataArray[4]);
    if (scales.indexOf(dataArray[2]) == -1) scales.push(dataArray[2]);
  }

  vendors.sort();
  types.sort();
  scales.sort(function (a, b) {
    return a - b;
  });

  var outh = '<ul class="meganav__nav page-width">';
  outh += ' <div class="grid grid--no-gutters meganav__scroller--has-list">';
  outh += '  <div class="grid__item meganav__list one-fifth">';
  var outf = '                  </div>';
  outf += '                </div>';
  outf += '              </ul>';

  var out = '';
  for (var v = 0; v < vendors.length; v++) {
    out +=
      '   <li><input class="vendor-toggle" id="toggle-' +
      vendors[v] +
      '" value="' +
      vendors[v] +
      '" type="checkbox" checked> ' +
      vendors[v].toUpperCase() +
      '</li>';
  }
  $('#SiteNavLinklist-Vendor').html(outh + out + outf);

  out = '';
  for (var v = 0; v < types.length; v++) {
    out +=
      '   <li><input class="types-toggle" id="toggle-' +
      types[v] +
      '" value="' +
      types[v] +
      '" type="checkbox" checked> ' +
      types[v].toUpperCase().replace('_', ' ') +
      '</li>';
  }
  $('#SiteNavLinklist-Type').html(outh + out + outf);

  out = '';
  var out2 = '';
  var out3 = '';
  for (var s = 0; s < scales.length; s++) {
    var checked = 'checked';
    var t = String(scales[s]);
    if (t.includes('-h')) {
      t = t.replace('-h', '');
      out2 +=
        '   <li><input class="scale-toggle" id="toggle-' +
        scales[s] +
        '" value=' +
        scales[s] +
        ' type="checkbox" ' +
        checked +
        '> Historic 1:' +
        t +
        '</li>';
    } else if (t.includes('t') || t.includes('v')) {
      var e = String(scales[s])
        .replace('aust', 'Australia')
        .replace('voy', 'Voyager')
        .replace('cst', 'Coastal')
        .replace('pt', 'Port');
      out3 +=
        '   <li><input class="scale-toggle" id="toggle-' +
        scales[s] +
        '" value=' +
        scales[s] +
        ' type="checkbox" ' +
        checked +
        '> ' +
        e +
        ' Pack</li>';
    } else {
      out +=
        '   <li><input class="scale-toggle" id="toggle-' +
        scales[s] +
        '" value=' +
        scales[s] +
        ' type="checkbox" ' +
        checked +
        '> 1:' +
        scales[s] +
        '</li>';
    }
  }
  if (out2 != '') {
    out2 = '<li style="border-bottom: 1px solid black; width: 50%"></li>' + out2;
  }
  $('#SiteNavLinklist-Scale').html(outh + out + out2 + out3 + outf);

  infoBubble = new google.maps.InfoWindow({
    content: '',
    disableAutoPan: true
  });

  function openInfoBubble(event) {
    var contentString =
      '<div style="display:inline; text-align:center">' + this.popUpContent + '</div>';
    infoBubble.setContent(contentString);
    infoBubble.setPosition(event.latLng);
    infoBubble.open(map);
  }

  function updateVendors() {
    showvendors = [];
    $('.vendor-toggle:checkbox:checked').each(function () {
      showvendors.push($(this).val());
    });
  }

  function updateTypes() {
    showtypes = [];
    $('.types-toggle:checkbox:checked').each(function () {
      showtypes.push($(this).val());
    });
  }

  function updateScales() {
    showscales = [];
    $('.scale-toggle:checkbox:checked').each(function () {
      if ($(this).val().includes('t') || $(this).val().includes('v')) {
        showscales.push(
          $(this)
            .val()
            .replace('Australia', 'aust')
            .replace('Voyage', 'voy')
            .replace('Coastal', 'cst')
            .replace('Port', 'pt')
        );
      } else {
        showscales.push($(this).val());
      }
    });
  }

  $('.vendor-toggle').on('change', function () {
    updateVendors();
    drawMatching(true);
  });

  $('.types-toggle').on('change', function () {
    updateTypes();
    drawMatching(true);
  });

  $('.scale-toggle').on('change', function () {
    updateScales();
    drawMatching(true);
  });

  updateVendors();
  updateTypes();
  updateScales();

  if (!bounds.isEmpty()) {
    map.fitBounds(bounds);
  }
}
